export const addToArchiveValidate = (archiveData) => {

    const errors = {}

    if (archiveData) {
        if (!archiveData.reason.trim()) {
            errors.reason = "لطفا عنوان را وارد کنید"
        } else {
            delete errors.reason
        }
        if (!archiveData.reason.trim()) {
            errors.reason = "لطفا دلیل را وارد کنید"
        } else {
            delete errors.reason
        }
        if (!archiveData.description.trim()) {
            errors.description = "لطفا توضیحات را وارد کنید"
        } else {
            delete errors.description
        }
        if (archiveData.date == "") {
            errors.date = "لطفا تاریخ را وارد کنید"
        } else {
            delete errors.date
        }
        // if (archiveData.file === undefined) {
        //     errors.file = "لطفا فایل را وارد کنید"
        // } else {
        //     delete errors.file
        // }
    }

    return errors;

}